import api from '../services/api';
import { getInstallId } from './installId';

const FIREBASE_CDN = 'https://www.gstatic.com/firebasejs/10.13.2';

function firebaseConfig() {
  const apiKey = (process.env.REACT_APP_FIREBASE_API_KEY || '').trim();
  const projectId = (process.env.REACT_APP_FIREBASE_PROJECT_ID || '').trim();
  const appId = (process.env.REACT_APP_FIREBASE_APP_ID || '').trim();
  const messagingSenderId = (process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '').trim();
  if (!apiKey || !projectId || !appId) return null;
  return {
    apiKey,
    authDomain: (process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '').trim() || undefined,
    projectId,
    appId,
    messagingSenderId: messagingSenderId || undefined,
  };
}

function loadScript(src) {
  return new Promise((resolve, reject) => {
    if ([...document.getElementsByTagName('script')].some((s) => s.src === src)) {
      resolve();
      return;
    }
    const el = document.createElement('script');
    el.src = src;
    el.async = true;
    el.onload = () => resolve();
    el.onerror = () => reject(new Error(`falha ao carregar ${src}`));
    document.head.appendChild(el);
  });
}

export function isWebPushConfigured() {
  return Boolean(firebaseConfig() && process.env.REACT_APP_FIREBASE_VAPID_KEY);
}

export async function registerWebPush() {
  if (typeof window === 'undefined' || !('Notification' in window) || !('serviceWorker' in navigator)) {
    return { ready: false, reason: 'unsupported' };
  }
  const cfg = firebaseConfig();
  const vapid = (process.env.REACT_APP_FIREBASE_VAPID_KEY || '').trim();
  if (!cfg || !vapid) {
    return { ready: false, reason: 'unconfigured' };
  }
  try {
    await loadScript(`${FIREBASE_CDN}/firebase-app-compat.js`);
    await loadScript(`${FIREBASE_CDN}/firebase-messaging-compat.js`);
    const firebase = window.firebase;
    if (!firebase) return { ready: false, reason: 'sdk' };
    const app = firebase.apps?.length ? firebase.app() : firebase.initializeApp(cfg);
    const messaging = firebase.messaging(app);
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return { ready: false, reason: 'denied' };
    await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    const token = await messaging.getToken({ vapidKey: vapid });
    if (!token || token.length < 10) return { ready: false, reason: 'token' };
    await api.post('/api/v1/devices', {
      fcm_token: token,
      platform: 'web',
      subject_type: 'servidor',
      push_enabled: true,
      locale: 'pt_BR',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Sao_Paulo',
    });
    await api.post('/api/v1/devices/merge', { install_id: getInstallId() });
    return { ready: true };
  } catch (err) {
    return { ready: false, reason: 'error', error: err };
  }
}
